import React, { FC } from 'react';
import { Redirect, useRoute } from 'wouter';

export const NewEditorItem: FC = () => {
  const [, params] = useRoute('/neweditor/:id');
  return (<>{params && <Redirect to={`/editor/${params.id}`} />}</>);
};
